
export interface IWeatherCity{
  label: string,
  value:string,
  temp: string,
  precip: string,
  wind:string
}

export const weatherData: {[index: string] : IWeatherCity[]} = {
  Alabama:
    [{
      label: 'Birmingham',
      value: 'Birmingham',
      temp: '62.2',
      precip: '52.2',
      wind: '7.2'
    },
      {
        label: 'Mobile',
        value: 'Mobile',
        temp: '67.5',
        precip: '64.6',
        wind: '9'
      },
      {
        label: 'Montgomery',
        value: 'Montgomery',
        temp: '67.5',
        precip: '49.2',
        wind: '6.7'
      }],
  Alaska:
    [{
      label: 'Anchorage',
      value: 'Anchorage',
      temp: '35.3',
      precip: '15.2',
      wind: '6.9'
    },
      {
        label: 'Fairbanks',
        value: 'Fairbanks',
        temp: '25.9',
        precip: '10.4',
        wind: '5.5'
      },
      {
        label: 'King Salmon',
        value: 'King Salmon',
        temp: '32.8',
        precip: '19.3',
        wind: '10.8'
      }],
  Arizona:
    [{
      label: 'Flagstaff',
      value: 'Flagstaff',
      temp: '45.4',
      precip: '20.9',
      wind: '7.1'
    },
      {
        label: 'Phoenix',
        value: 'Phoenix',
        temp: '71.2',
        precip: '7.1',
        wind: '6.3'
      },
      {
        label: 'Tuscon',
        value: 'Tuscon',
        temp: '68',
        precip: '11.1',
        wind: '8.2'
      }],
  Arkansas:
    [{
      label: 'Little Rock',
      value: 'Little Rock',
      temp: '61.9',
      precip: '49.2',
      wind: '7.9'
    }],
  California:
    [{
      label: 'Bakersfield',
      value: 'Bakersfield',
      temp: '65.6',
      precip: '5.7',
      wind: '6.4'
    },
      {
        label: 'Fresno',
        value: 'Fresno',
        temp: '62.5',
        precip: '10.5',
        wind: '6.4'
      },
      {
        label: 'Los Angeles',
        value: 'Los Angeles',
        temp: '62.6',
        precip: '12.1',
        wind: '7.5'
      },
      {
        label: 'Sacramento',
        value: 'Sacramento',
        temp: '60.6',
        precip: '17.1',
        wind: '8.1'
      },
      {
        label: 'San Diego',
        value: 'San Diego',
        temp: '63.8',
        precip: '9.3',
        wind: '6.9'
      },
      {
        label: 'San Francisco',
        value: 'San Francisco',
        temp: '56.6',
        precip: '19.7',
        wind: '10.5'
      },
      {
        label: 'Santa Barbara',
        value: 'Santa Barbara',
        temp: '58.9',
        precip: '16.2',
        wind: '6.1'
      }],
  Colorado:
    [{
      label: 'Colorado Springs',
      value: 'Colorado Springs',
      temp: '48.9',
      precip: '44.4',
      wind: '9.2'
    },
      {
        label: 'Denver',
        value: 'Denver',
        temp: '50.3',
        precip: '15.3',
        wind: '8.8'
      }],
  Connecticut:
    [{
      label: 'Hartford',
      value: 'Hartford',
      temp: '49.8',
      precip: '44.4',
      wind: '9.2'
    }],
  DC:
    [{
      label: 'Washington',
      value: 'Washington',
      temp: '57.5',
      precip: '39',
      wind: '9.3'
    }],
  Delaware:
    [{
      label: 'Wilmington',
      value: 'Wilmington',
      temp: '54',
      precip: '41.4',
      wind: '9.2'
    }],
  Florida:
    [{
      label: 'Jacksonville',
      value: 'Jacksonville',
      temp: '68',
      precip: '52.8',
      wind: '8.1'
    },
      {
        label: 'Miami',
        value: 'Miami',
        temp: '75.6',
        precip: '57.6',
        wind: '9.2'
      },
      {
        label: 'Orlando',
        value: 'Orlando',
        temp: '72.4',
        precip: '47.8',
        wind: '8.6'
      },
      {
        label: 'Tallahassee',
        value: 'Tallahassee',
        temp: '67.2',
        precip: '64.6',
        wind: '6.4'
      },
      {
        label: 'Tampa',
        value: 'Tampa',
        temp: '72',
        precip: '46.7',
        wind: '8.5'
      },
      {
        label: 'West Palm Beach',
        value: 'West Palm Beach',
        temp: '74.6',
        precip: '59.7',
        wind: '9.4'
      }],
  Georgia:
    [{
      label: 'Atlanta',
      value: 'Atlanta',
      temp: '61.2',
      precip: '48.6',
      wind: '9.1'
    },
      {
        label: 'Augusta',
        value: 'Augusta',
        temp: '63.2',
        precip: '43.1',
        wind: '6.5'
      },
      {
        label: 'Macon',
        value: 'Macon',
        temp: '64.7',
        precip: '44.9',
        wind: '7.7'
      },
      {
        label: 'Savannah',
        value: 'Savannah',
        temp: '65.9',
        precip: '49.7',
        wind: '7.9'
      }],
  Hawaii:
    [{
      label: 'Hilo',
      value: 'Hilo',
      temp: '73.6',
      precip: '128.2',
      wind: '7.1'
    },
      {
        label: 'Honolulu',
        value: 'Honolulu',
        temp: '77',
        precip: '23.5',
        wind: '11.5'
      }],
  Idaho:
    [{
      label: 'Boise',
      value: 'Boise',
      temp: '51.1',
      precip: '11.7',
      wind: '8.8'
    },
      {
        label: 'Pocatello',
        value: 'Pocatello',
        temp: '46.6',
        precip: '10.9',
        wind: '10.2'
      }],
  Illinois:
    [{
      label: 'Chicago',
      value: 'Chicago',
      temp: '49.2',
      precip: '33.3',
      wind: '10.2'
    },
      {
        label: 'Peoria',
        value: 'Peoria',
        temp: '50.4',
        precip: '34.9',
        wind: '10.1'
      },
      {
        label: 'Springfield',
        value: 'Springfield',
        temp: '52.6',
        precip: '33.8',
        wind: '11.3'
      }],
  Indiana:
    [{
      label: 'Evansville',
      value: 'Evansville',
      temp: '55.7',
      precip: '41.6',
      wind: '8.2'
    },
      {
        label: 'Fort Wayne',
        value: 'Fort Wayne',
        temp: '49.7',
        precip: '34.4',
        wind: '10.1'
      },
      {
        label: 'Indianapolis',
        value: 'Indianapolis',
        temp: '52.1',
        precip: '39.1',
        wind: '9.6'
      },
      {
        label: 'South Bend',
        value: 'South Bend',
        temp: '49.4',
        precip: '38.2',
        wind: '10.4'
      }],
  Iowa:
    [{
      label: 'Des Moines',
      value: 'Des Moines',
      temp: '49.7',
      precip: '30.8',
      wind: '10.9'
    },
      {
        label: 'Sioux city',
        value: 'Sioux city',
        temp: '48.4',
        precip: '25.4',
        wind: '11'
      },
      {
        label: 'Waterloo',
        value: 'Waterloo',
        temp: '46.1',
        precip: '33.1',
        wind: '10.7'
      }],
  Kansas:
    [{
      label: 'Topeka',
      value: 'Topeka',
      temp: '54.1',
      precip: '28.6',
      wind: '10.1'
    },
      {
        label: 'Wichita',
        value: 'Wichita',
        temp: '56.4',
        precip: '40.1',
        wind: '12.3'
      }],
  Kentucky:
    [{
      label: 'Lexington',
      value: 'Lexington',
      temp: '54.9',
      precip: '45.7',
      wind: '7.1'
    },
      {
        label: 'Louisville',
        value: 'Louisville',
        temp: '56.2',
        precip: '43.6',
        wind: '8.3'
      }],
  Louisiana:
    [{
      label: 'Baton Rouge',
      value: 'Baton Rouge',
      temp: '67.5',
      precip: '55.8',
      wind: '7.7'
    },
      {
        label: 'Lake Charles',
        value: 'Lake Charles',
        temp: '68',
        precip: '53',
        wind: '8.6'
      },
      {
        label: 'New Orleans',
        value: 'New Orleans',
        temp: '68.2',
        precip: '59.7',
        wind: '8.2'
      },
      {
        label: 'Shreveport',
        value: 'Shreveport',
        temp: '65.4',
        precip: '43.8',
        wind: '8.5'
      }],
  Maine:
    [{
      label: 'Caribou',
      value: 'Caribou',
      temp: '38.9',
      precip: '36.6',
      wind: '11.2'
    },
      {
        label: 'Portland',
        value: 'Portland',
        temp: '45',
        precip: '43.8',
        wind: '8.7'
      }],
  Maryland:
    [{
      label: 'Baltimore',
      value: 'Baltimore',
      temp: '55.1',
      precip: '41.8',
      wind: '9.2'
    }],
  Massachusetts:
    [{
      label: 'Boston',
      value: 'Boston',
      temp: '51.5',
      precip: '43.8',
      wind: '12.4'
    },
      {
        label: 'Worcester',
        value: 'Worcester',
        temp: '46.8',
        precip: '47.6',
        wind: '12.4'
      }],
  Michigan:
    [{
      label: 'Detroit',
      value: 'Detroit',
      temp: '48.6',
      precip: '4',
      wind: '10.2'
    },
      {
        label: 'Flint',
        value: 'Flint',
        temp: '46.8',
        precip: '29.2',
        wind: '10.6'
      },
      {
        label: 'Grand Rapids',
        value: 'Grand Rapids',
        temp: '47.5',
        precip: '34.4',
        wind: '9.7'
      }],
  Minnesota:
    [{
      label: 'Duluth',
      value: 'Duluth',
      temp: '38.2',
      precip: '29.7',
      wind: '11.2'
    },
      {
        label: 'Minneapolis',
        value: 'Minneapolis',
        temp: '44.7',
        precip: '26.4',
        wind: '10.6'
      }],
  Mississippi:
    [{
      label: 'Jackson',
      value: 'Jackson',
      temp: '64.6',
      precip: '52.8',
      wind: '7.4'
    }],
  Missouri:
    [{
      label: 'Kansas city',
      value: 'Kansas city',
      temp: '56.3',
      precip: '35.2',
      wind: '10.7'
    }],
  Montana:
    [{
      label: 'Great Falls',
      value: 'Great Falls',
      temp: '44.7',
      precip: '15.2',
      wind: '12.8'
    }],
  Nebraska:
    [{
      label: 'Omaha',
      value: 'Omaha',
      temp: '49.5',
      precip: '29.9',
      wind: '10.6'
    }],
  Nevada:
    [{
      label: 'Las Vegas',
      value: 'Las Vegas',
      temp: '66.3',
      precip: '4.2',
      wind: '9.2'
    },
      {
        label: 'Reno',
        value: 'Reno',
        temp: '49.4',
        precip: '7.5',
        wind: '6.5'
      }],
  'New Jersey':
    [{
      label: 'Atlantic City',
      value: 'Atlantic City',
      temp: '53.1',
      precip: '41.9',
      wind: '10.1'
    }],
  'New Mexico':
    [{
      label: 'Albuquerque',
      value: 'Albuquerque',
      temp: '56.2',
      precip: '8.1',
      wind: '9'
    }],
  'New York':
    [{
      label: 'Albany',
      value: 'Albany',
      temp: '47.3',
      precip: '35.7',
      wind: '8.9'
    },
      {
        label: 'Buffalo',
        value: 'Buffalo',
        temp: '47.6',
        precip: '37.5',
        wind: '12.1'
      },
      {
        label: 'New York City',
        value: 'New York City',
        temp: '54.5',
        precip: '44.1',
        wind: '12.1'
      },
      {
        label: 'Rochester',
        value: 'Rochester',
        temp: '47.9',
        precip: '31.3',
        wind: '9.7'
      },
      {
        label: 'Syracuse',
        value: 'Syracuse',
        temp: '47.7',
        precip: '39.1',
        wind: '9.7'
      }],
  'North Carolina':
    [{
      label: 'Charlotte',
      value: 'Charlotte',
      temp: '60',
      precip: '43.2',
      wind: '7.5'
    },
      {
        label: 'Greensboro',
        value: 'Greensboro',
        temp: '57.9',
        precip: '42.5',
        wind: '7.5'
      },
      {
        label: 'Ralieigh',
        value: 'Ralieigh',
        temp: '59',
        precip: '41.8',
        wind: '7.8'
      },
      {
        label: 'Wilmington',
        value: 'Wilmington',
        temp: '63.4',
        precip: '53.4',
        wind: '8.8'
      }],
  'North Dakota':
    [{
      label: 'Bismarck',
      value: 'Bismarck',
      temp: '41.3',
      precip: '15.4',
      wind: '10.3'
    },
      {
        label: 'Fargo',
        value: 'Fargo',
        temp: '40.5',
        precip: '19.6',
        wind: '12.4'
      }],
  Ohio:
    [{
      label: 'Akron-Canton',
      value: 'Akron-Canton',
      temp: '49.5',
      precip: '35.9',
      wind: '9.8'
    },
      {
        label: 'Cleveland',
        value: 'Cleveland',
        temp: '49.6',
        precip: '35.4',
        wind: '10.7'
      },
      {
        label: 'Columbus',
        value: 'Columbus',
        temp: '51.7',
        precip: '37',
        wind: '8.7'
      },
      {
        label: 'Dayton',
        value: 'Dayton',
        temp: '51.9',
        precip: '34.7',
        wind: '10.1'
      },
      {
        label: 'Youngstown',
        value: 'Youngstown',
        temp: '48.3',
        precip: '37.3',
        wind: '10'
      }],
  Oklahoma:
    [{
      label: 'Oklahoma City',
      value: 'Oklahoma City',
      temp: '59.9',
      precip: '30.9',
      wind: '12.5'
    },
      {
        label: 'Tulsa',
        value: 'Tulsa',
        temp: '60.3',
        precip: '38.8',
        wind: '10.4'
      }],
  Oregon:
    [{
      label: 'Medford',
      value: 'Medford',
      temp: '53.6',
      precip: '19.8',
      wind: '4.8'
    },
      {
        label: 'Portland',
        value: 'Portland',
        temp: '53',
        precip: '37.4',
        wind: '7.9'
      },
      {
        label: 'Salem',
        value: 'Salem',
        temp: '52',
        precip: '40.4',
        wind: '7'
      }],
  Pennsylvania:
    [{
      label: 'Harrisburg',
      value: 'Harrisburg',
      temp: '53',
      precip: '39.1',
      wind: '7.6'
    },
      {
        label: 'Philadelphia',
        value: 'Philadelphia',
        temp: '54.3',
        precip: '41.4',
        wind: '9.5'
      },
      {
        label: 'Pittsburgh',
        value: 'Pittsburgh',
        temp: '50.3',
        precip: '36.3',
        wind: '9.1'
      }],
  'Rhode Island':
    [{
      label: 'Providence',
      value: 'Providence',
      temp: '50.3',
      precip: '45.3',
      wind: '10.6'
    }],
  'South Carolina':
    [{
      label: 'Charleston',
      value: 'Charleston',
      temp: '64.8',
      precip: '51.6',
      wind: '8.7'
    },
      {
        label: 'Columbia',
        value: 'Columbia',
        temp: '63.3',
        precip: '49.1',
        wind: '6.9'
      }],
  'South Dakota':
    [{
      label: 'Huron',
      value: 'Huron',
      temp: '44.7',
      precip: '18.7',
      wind: '11.6'
    },
      {
        label: 'Rapid City',
        value: 'Rapid City',
        temp: '46.7',
        precip: '16.3',
        wind: '11.3'
      }],
  Tennessee:
    [{
      label: 'Chattanooga',
      value: 'Chattanooga',
      temp: '59.4',
      precip: '52.6',
      wind: '6.1'
    },
      {
        label: 'Knoxville',
        value: 'Knoxville',
        temp: '58.9',
        precip: '47.3',
        wind: '7.1'
      },
      {
        label: 'Memphis',
        value: 'Memphis',
        temp: '61.8',
        precip: '51.6',
        wind: '9'
      },
      {
        label: 'Nashville',
        value: 'Nashville',
        temp: '59.2',
        precip: '48.5',
        wind: '8'
      }],
  Texas:
    [{
      label: 'Amarillo',
      value: 'Amarillo',
      temp: '57.2',
      precip: '19.1',
      wind: '13.6'
    },
      {
        label: 'Brownsville',
        value: 'Brownsville',
        temp: '73.6',
        precip: '25.4',
        wind: '11.6'
      },
      {
        label: 'Corpus Christi',
        value: 'Corpus Christi',
        temp: '72.1',
        precip: '30.2',
        wind: '12'
      },
      {
        label: 'Dallas',
        value: 'Dallas',
        temp: '66',
        precip: '29.5',
        wind: '10.8'
      },
      {
        label: 'El Paso',
        value: 'El Paso',
        temp: '63.4',
        precip: '7.8',
        wind: '9'
      },
      {
        label: 'Galveston',
        value: 'Galveston',
        temp: '69.6',
        precip: '40.2',
        wind: '11'
      },
      {
        label: 'Houston',
        value: 'Houston',
        temp: '68.3',
        precip: '44.8',
        wind: '7.8'
      },
      {
        label: 'Lubbock',
        value: 'Lubbock',
        temp: '59.9',
        precip: '17.8',
        wind: '12.4'
      },
      {
        label: 'Midland',
        value: 'Midland',
        temp: '63.5',
        precip: '13.7',
        wind: '11.1'
      },
      {
        label: 'San Antonio',
        value: 'San Antonio',
        temp: '68.7',
        precip: '29.2',
        wind: '9.4'
      },
      {
        label: 'Waco',
        value: 'Waco',
        temp: '67',
        precip: '31',
        wind: '11.3'
      },
      {
        label: 'Wichita Falls',
        value: 'Wichita Falls',
        temp: '63.5',
        precip: '26.7',
        wind: '11.7'
      }],
  Utah:
    [{
      label: 'Salt Lake City',
      value: 'Salt Lake City',
      temp: '51.7',
      precip: '15.3',
      wind: '8.8'
    }],
  Vermont:
    [{
      label: 'Burlington',
      value: 'Burlington',
      temp: '44.1',
      precip: '33.7',
      wind: '8.8'
    }],
  Virginia:
    [{
      label: 'Norfolk',
      value: 'Norfolk',
      temp: '59.5',
      precip: '45.2',
      wind: '10.6'
    },
      {
        label: 'Richmond',
        value: 'Richmond',
        temp: '57.7',
        precip: '44.1',
        wind: '7.6'
      },
      {
        label: 'Roanoke',
        value: 'Roanoke',
        temp: '56.1',
        precip: '39.2',
        wind: '8.2'
      }],
  Washington:
    [{
      label: 'Olympia',
      value: 'Olympia',
      temp: '49.6',
      precip: '51',
      wind: '6.7'
    },
      {
        label: 'Seattle',
        value: 'Seattle',
        temp: '52.7',
        precip: '38.8',
        wind: '9'
      },
      {
        label: 'Spokane',
        value: 'Spokane',
        temp: '47.2',
        precip: '16.7',
        wind: '8.8'
      }],
  'West Virginia':
    [{
      label: 'Charleston',
      value: 'Charleston',
      temp: '54.8',
      precip: '42.4',
      wind: '6.4'
    },
      {
        label: 'Huntington',
        value: 'Huntington',
        temp: '55.2',
        precip: '40.7',
        wind: '6.5'
      }],
  Wisconsin:
    [{
      label: 'Green Bay',
      value: 'Green Bay',
      temp: '43.6',
      precip: '28',
      wind: '10.1'
    },
      {
        label: 'Madison',
        value: 'Madison',
        temp: '45.2',
        precip: '30.8',
        wind: '9.8'
      },
      {
        label: 'Milwaukee',
        value: 'Milwaukee',
        temp: '46.1',
        precip: '30.9',
        wind: '11.6'
      }],
  Wyoming:
    [{
      label: 'Casper',
      value: 'Casper',
      temp: '45.2',
      precip: '11.4',
      wind: '13'
    },
      {
        label: 'Cheyenne',
        value: 'Cheyenne',
        temp: '45.7',
        precip: '13.3',
        wind: '12.9'
      }]
};
